var _path, _g, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.384 10.6611L23.8156 12.067C23.6362 12.5456 23.6362 13.0541 23.8156 13.5328L24.384 14.9387C24.713 15.7763 24.4438 16.7335 23.696 17.272L22.4396 18.1395C22.0208 18.4386 21.7516 18.8873 21.632 19.3659L21.3627 20.8616C21.1832 21.759 20.4354 22.4171 19.538 22.447L18.0124 22.5068C17.5039 22.5368 17.0253 22.7461 16.6663 23.1051L15.6193 24.2119C14.9911 24.87 14.004 25.0196 13.2262 24.5709L11.91 23.7931C11.4613 23.5239 10.9528 23.4641 10.4443 23.5837L8.94859 23.9427C8.0811 24.1521 7.15378 23.7333 6.73499 22.9256L6.04698 21.5496C5.80767 21.1009 5.41879 20.7419 4.94017 20.5924L3.50432 20.1138C2.63683 19.8146 2.09838 18.977 2.18813 18.0796L2.33769 16.554C2.39752 16.0455 2.24795 15.537 1.9189 15.1481L0.961669 13.9516C0.393311 13.2336 0.393311 12.2465 0.961669 11.5286L1.9189 10.332C2.24795 9.94313 2.39752 9.4346 2.33769 8.92607L2.18813 7.40048C2.09838 6.50307 2.63683 5.66549 3.50432 5.36636L4.94017 4.88774C5.41879 4.73817 5.80767 4.37921 6.04698 3.93051L6.73499 2.55448C7.15378 1.74681 8.05119 1.32802 8.94859 1.53742L10.4443 1.89638C10.9229 2.01604 11.4613 1.95621 11.91 1.68699L13.2262 0.909235C14.004 0.460531 14.9911 0.580185 15.6193 1.2682L16.6663 2.375C17.0253 2.73396 17.5039 2.97327 18.0124 2.97327L19.538 3.0331C20.4354 3.06301 21.2132 3.72111 21.3627 4.61852L21.632 6.1142C21.7217 6.62273 22.0208 7.07143 22.4396 7.34065L23.696 8.20815C24.4438 8.86625 24.743 9.82348 24.384 10.6611Z",
    fill: "url(#paint0_linear_1349_31575)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.60248 22.8359L6.91447 21.4599C6.67516 21.0112 6.28629 20.6522 5.80767 20.5027L4.37182 20.024C3.50432 19.7249 2.96588 18.8873 3.05562 17.9899L3.20519 16.4643C3.26501 15.9558 3.11545 15.4473 2.7864 15.0584L1.82916 13.8619C1.2608 13.1439 1.2608 12.1568 1.82916 11.4389L2.7864 10.2423C3.11545 9.85343 3.26501 9.3449 3.20519 8.83637L3.05562 7.31078C2.96588 6.41337 3.50432 5.57579 4.37182 5.27665L5.80767 4.79804C6.28629 4.64847 6.67516 4.28951 6.91447 3.8408L7.60248 2.46478C7.84179 1.98616 8.26058 1.65711 8.70928 1.50754C7.90162 1.38789 7.09395 1.80668 6.73499 2.55452L6.04698 3.93054C5.80767 4.37925 5.41879 4.73821 4.94017 4.88778L3.50432 5.3664C2.63683 5.66553 2.09838 6.50311 2.18813 7.40052L2.33769 8.92611C2.39752 9.43464 2.24795 9.94317 1.9189 10.3321L0.961669 11.5286C0.393311 12.2465 0.393311 13.2337 0.961669 13.9516L1.9189 15.1481C2.24795 15.537 2.39752 16.0455 2.33769 16.5541L2.18813 18.0797C2.09838 18.9771 2.63683 19.8147 3.50432 20.1138L4.94017 20.5924C5.41879 20.742 5.80767 21.1009 6.04698 21.5496L6.73499 22.9257C7.15378 23.7333 8.05119 24.1521 8.94859 23.9427L9.12807 23.9128C8.46998 23.7932 7.90162 23.4342 7.60248 22.8359Z",
    fill: "url(#paint1_linear_1349_31575)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7472 1.59688L14.0634 0.81913C14.1831 0.759303 14.3027 0.699476 14.4224 0.669562C14.0036 0.609735 13.5549 0.699476 13.1959 0.908871L11.8797 1.68662C11.7601 1.74645 11.6404 1.80628 11.5208 1.83619C11.9395 1.89602 12.3583 1.83619 12.7472 1.59688Z",
    fill: "url(#paint2_linear_1349_31575)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8503 22.386C18.7007 22.386 18.5512 22.4159 18.4315 22.4458L19.5084 22.386C19.658 22.386 19.7776 22.3561 19.9272 22.3262L18.8503 22.386Z",
    fill: "url(#paint3_linear_1349_31575)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0642 24.4502L12.748 23.6725C12.2993 23.4032 11.7908 23.3434 11.2823 23.4631L11.1028 23.493C11.372 23.5229 11.6113 23.6126 11.8506 23.7323L13.1668 24.51C13.6754 24.8092 14.2437 24.8391 14.7822 24.6596C14.5428 24.6596 14.3035 24.5998 14.0642 24.4502Z",
    fill: "url(#paint4_linear_1349_31575)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78198 10.9012L11.5212 15.1788L19.1791 9.0166",
    fill: "url(#paint5_linear_1349_31575)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6242 17.3929C10.2054 17.3929 9.78658 17.2134 9.48744 16.8843L5.74825 12.6067C5.2098 11.9785 5.26963 11.0512 5.8679 10.4828C6.49608 9.94437 7.42341 10.0042 7.99176 10.6025L10.8036 13.8032L17.3547 8.53844C17.9829 8.02991 18.9401 8.11965 19.4487 8.77774C19.9572 9.43584 19.8675 10.3632 19.2094 10.8717L11.5515 17.0638C11.2823 17.2732 10.9532 17.3929 10.6242 17.3929Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1349_31575",
    x1: 12.5354,
    y1: 0.643555,
    x2: 12.5354,
    y2: 24.8282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1349_31575",
    x1: 4.83174,
    y1: 1.4873,
    x2: 4.83174,
    y2: 23.9962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C3664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11274F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1349_31575",
    x1: 12.9716,
    y1: 0.651367,
    x2: 12.9716,
    y2: 1.85777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C3664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11274F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1349_31575",
    x1: 19.1794,
    y1: 22.3262,
    x2: 19.1794,
    y2: 22.4458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C3664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11274F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1349_31575",
    x1: 12.9425,
    y1: 23.4043,
    x2: 12.9425,
    y2: 24.7707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C3664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11274F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1349_31575",
    x1: 13.4805,
    y1: 9.0166,
    x2: 13.4805,
    y2: 15.1788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700",
    stopOpacity: 0.97
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/checkMark.f083fc6ce07341bd51cbae199959d92f.svg";
export { ForwardRef as ReactComponent };